import { GROUPING_LOCATION_SERVICE_NAME, GroupingLocationServiceProvider } from './grouping-locations.service'
import { GROUPING_LOCATION_CONTEXT_MENU_SERVICE_NAME, GroupingLocationContextMenuServiceProvider } from './grouping-locations.context-menu.service'

export const GROUPING_LOCATION_SERVICES_MODULE_NAME = 'simax.services.grouping-location'

const groupingLocationServicesModule = angular.module(GROUPING_LOCATION_SERVICES_MODULE_NAME, [])

groupingLocationServicesModule.provider(GROUPING_LOCATION_SERVICE_NAME, GroupingLocationServiceProvider)
groupingLocationServicesModule.provider(GROUPING_LOCATION_CONTEXT_MENU_SERVICE_NAME, GroupingLocationContextMenuServiceProvider)
